<template>
    <button type="button" class="d-none" data-toggle="modal" data-target=".shareFileModals" id="shareFileBtn"> </button>
    <div class="modal fade shareFileModals move_mdrivefolder shareFilefolder" id="fileShareModalId" tabindex="-1" role="dialog" aria-hidden="true">
        <div class=" modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <form @submit.prevent="shareFile" id="shareFile" class="shareFile">
                    <div class="modal-header">
                        <h5 class="modal-title">Share "{{$store.state.fileNameParam}}"</h5>
                        <button type="button" class="close" id="closeShareFilePop" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group col-md-12">
                                <!-- v-model="selected" -->
                            <Multiselect
                                mode="tags"
                                v-model="v$.form.user_id.$model" 
                                placeholder="Choose your User"
                                :close-on-select="false"
                                :filter-results="false"
                                :min-chars="1"
                                :resolve-on-load="false"
                                :delay="0"
                                :searchable="true"
                                :options="loadOptions"
                                @change="userChangeEvent($event)"
                                track-by="id"
                                label="label"
                                noOptionsText="Search Users here..."
                                loadingText="Loading users..."
                            />
                        </div>
                        <div class="form-group col-md-12" v-if="shouldShowAccessSelect">
                            <Select2 
                                v-bind:id="'accessTypeId'"
                                :modelValue="[v$.form.access_type.$model]"
                                v-model="v$.form.access_type.$model" 
                                :select=2 
                                :placeholder="'Select Access Type'"
                                :options="$store.state.stausShareOptions" 
                                :settings="{ minimumResultsForSearch: -1, dropdownParent: '#fileShareModalId' }"
                            />
                        </div>
                        <div class="form-group col-md-12" v-if="$store.state.ownerData.length != 0">
                            <ul class="list-group" >
                                <li class="list-group-item">
                                    <div class="iq-avatar">
                                        <img :src="img_url+''+$store.state.ownerData.user_image" class="avatar-30 rounded" alt="#">
                                    </div>
                                    {{$store.state.ownerData.name}} - {{$store.state.ownerData.email}}
                                    <span>Owner</span>
                                </li>
                            </ul>
                        </div>
                        <div class="card" v-if="$store.state.sharedWith.length > 0">
                            
                            <div class="card-header d-flex justify-content-between">
                                <div class="header-title">
                                    <h4 class="card-title">People with access</h4>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-12">
                            <ul class="list-group" v-for="(item) in $store.state.sharedWith" :key="item._id">
                                <li class="list-group-item">
                                    <div class="iq-avatar">
                                        <img :src="img_url+''+item.user_image" class="avatar-30 rounded" alt="#">
                                    </div>
                                    {{item.name}} - {{item.email}}

                                    <Select2 
                                        v-model="$store.state.selectedAccessTypes[item.user_id]"
                                        :select=2 
                                        :placeholder="'Select Access Type'"
                                        :options="$store.state.stausShareEditOptions" 
                                        :settings="{ minimumResultsForSearch: -1, dropdownParent: '#fileShareModalId' }"
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary cancel" data-dismiss="modal">Close</button>
                        
                        <button type="submit" class="btn btn-primary" v-on:click="shareFileaccess" v-if="formLoader === 1">Send</button>
                        <button type="button" class="btn btn-primary" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>
                    </div>
                </form> 
            </div>
        </div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {
    required,
} from '@vuelidate/validators'
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import Select2 from 'vue3-select2-component';
import axios from 'axios'
import 
    { postCommon } 
from '../../utils/api.js'
export default {
    name: 'ShareFileData',
    components: {
        Multiselect,
        Select2,
    },
    data() {
        return {
            img_url: process.env.VUE_APP_IMG_URL,
            searchKey: '',
            formLoader: 1,
            myValue: 1,
            teamList: [],
            selected: [],
            form: {
                file_id: '',
                access_type: 1,
                user_id: null,
            },
        }
    },
    computed: {
        shouldShowAccessSelect() {
            return this.v$.form.user_id.$model && this.v$.form.user_id.$model.length > 0;
        }
    },
    methods: {
        userChangeEvent(val) {
            if(val.length > 0) {
                console.log('userChangeEvent', val);
            } else {
                console.log(null);
            }
        },
        async shareFileaccess() {
            this.formLoader = 2

            // Make sure this.form.user_id is valid
            const accessData = this.$store.state.accessUsers.map(user_id => {
                const rawValue = this.$store.state.selectedAccessTypes[user_id];

                return {
                    user_id: user_id,
                    access_type: rawValue !== undefined && rawValue !== '' ? Number(rawValue) : null
                };
            });

            
            var user_id = this.form.user_id
            var file_id = this.$store.state.fileNameIdParam
            var access_type = this.form.access_type !== undefined && this.form.access_type !== '' ? Number(this.form.access_type) : null
               
            if(user_id === null || user_id.length === 0) {
                access_type = null;
            }

            let _post = {}
            _post = {
                user_id: user_id,
                id: file_id,
                access_type: access_type,
                accessData: accessData,
            }
            const resp = await postCommon('files/share-file', _post)
            if (resp.status == 200 && resp.data.status == 'success') {
                document.getElementById('closeShareFilePop').click();
                this.$toast.success(resp.data.message);
                // this.$store.state.home.reLoadFolder = Math.random();
                this.$store.state.home.reLoadFilecomponent = Math.random();
                // this.$store.state.home.reLoadFoldercomponent = Math.random();
            } else if (resp.status == 200 && resp.data.status == 'failure') {
                this.errorMessage = resp.data.message;
                this.$toast.error(resp.data.message);
            }
            this.formLoader = 1
            
        },
        async shareFileModal(id, name) {
            this.form.file_id = id;
            this.form.user_id = [];
            this.v$.$reset()
            this.fileName = '';
            this.sdadasaasd = '';
            this.fileName = name + '-' +id;
            let _post = {}
            _post = {
                _id: id
            }
            this.$store.state.sharedWith = [];
            this.$store.state.ownerData = [];
            const resp = await postCommon('files/share-users', _post)
            this.$store.state.sharedWith = resp.data.data.sharedWith;
            if(resp.data.data.owner){
                this.$store.state.ownerData = resp.data.data.owner;
            }
            this.$store.state.selectedAccessTypes = {};
            this.$store.state.accessUsers = [];
            
            // Optional: Initialize default access per user
            this.$store.state.sharedWith.forEach(user => {
                this.$store.state.selectedAccessTypes[user.user_id] = user.permission; // Or ['1'] for multi-select
                // this.selectedAccessTypes[user.user_id] = 2; // Or ['1'] for multi-select
                this.$store.state.accessUsers.push(user.user_id);
            });
            
            this.$store.state.fileNameParam = name;
            this.$store.state.fileNameIdParam = id;
            document.getElementById('shareFileBtn').click();
        },
        async loadOptions(query) {
            // Don’t show anything if user hasn’t typed yet
            if (!query) return []

            try {
            // 1. Await the HTTP call
            const resp = await axios.get(
                process.env.VUE_APP_API_URL + 'user/active',
                {
                    params: {
                        searchKey: query,
                        notUser: this.$store.state.accessUsers
                    }
                }
            )

            // 2. Pull out your users array
            const users = resp.data.data.records

            // 3. Filter out entries without a name, then map to {value,label}
            const options = users
                .filter(u => u.name)
                .map(u => ({
                value: u._id,
                label: `${u.name} (${u.email})`
                }))

            // 4. Return the array of cleaned options
            return options

            } catch (error) {
                console.error('Error fetching options:', error)
                return []
            }
        },
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        return {
            form: {
                user_id: {
                    required,
                },
                access_type: {
                    required
                }
            },
        }
    },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>